import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import FulfillmentPlannerContextDrivenOtherShippingOptions from '../../../../../fulfillment-planner/other-shipping-options';
import OtherShippingOptionsStyleContextProvider from '../../../../other-shipping-options/style-provider';
import { OrderDetailsSectionId, useOrderDetailsExpanderSection } from '../../order-details-expanded-section-provider';

import style from './other-shipping-options.module.less';
import expanderStyle from '../../../tab-section/expander-section/expander-section.module.less';
import sectionStyle from '../../../tab-section/section.module.less';
import sectionTitleStyle from '../../../tab-section/title.module.less';
import textStyle from 'ui-components/components/text/text.module.less';

const styleContextValue = {
  classes: {
    collapsibleSectionHeaderContent: classnames(expanderStyle['header-content'], textStyle.h4),
    collapsibleSectionContent: style.content,
    form: style.form,
    sectionTitle: classnames(style['section-title'], textStyle.label),
    optionSection: style['option-section'],
    billToRow: style['bill-to-row'],
    billToDropdown: style['bill-to-dropdown'],
    readonlyRow: style['read-only-row'],
    readonlyValueSection: classnames(style['read-only-value-section'], textStyle.paragraph),
  },
  shouldInputsBeFullWidth: true,
};

const OtherShippingOptions = ({ isReadOnly = false }) => {
  const { isExpanded, toggleIsExpanded } = useOrderDetailsExpanderSection(OrderDetailsSectionId.OtherShippingOptions);

  return (
    <OtherShippingOptionsStyleContextProvider value={styleContextValue}>
      <FulfillmentPlannerContextDrivenOtherShippingOptions
        className={classnames(style['other-shipping-options-section'], sectionStyle['order-details-section'])}
        headerClassName={classnames(expanderStyle.header, sectionTitleStyle['order-details-section-title'])}
        isReadOnly={isReadOnly}
        onClickHeader={toggleIsExpanded}
        open={isExpanded}
      />
    </OtherShippingOptionsStyleContextProvider>
  );
};

export default OtherShippingOptions;

OtherShippingOptions.propTypes = {
  isReadOnly: PropTypes.bool,
};
